import {
  CheckboxVisibility,
  CommandBarButton,
  DetailsList,
  IColumn,
  Icon,
  IContextualMenuItem,
  IDetailsRowProps,
  IIconProps,
  Label,
  Pivot,
  PivotItem,
  PrimaryButton,
  SearchBox,
  Stack,
} from '@fluentui/react';
import * as React from 'react';
import { MouseEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { _renderRow } from '../../control/function/detailList';
import { NoDataFound } from '../../control/noDataFound';
import Paging from '../../control/paging';
import * as Api from '../../api/src';
import '../../css/components/test.scss';
import useToken from '../account/login/useToken';
import { DialogContext } from '../../context/dialog.context';
import ButtonMenuContext from '../../control/ButtonMenuContext';
import { commonfn, TestService } from '../../common/commonfn';
import ModaFilterTest from './modal/filter/modalFilterTest';
import ModalTest from './modal/modalTest';
import ModalUnApproveTest from './modal/modalUnApproveTest';
import { LeftMenuContext } from '../../context/leftMenu.context';
import globalData from '../../common/globalData';
import { useHistory, useParams } from 'react-router-dom';
import { Loading } from '../../control/loading';

import moment from 'moment';
const TestsApi = new Api.TestsApi();
const UserApi = new Api.UserApi();
const defaultFilter = {
  Status: Api.TestStatusQueryEnum.All,
  VendorId: 0,
  ComponentId: 0,
  OrderBy: [{ ColumnName: 'Name' }],
  PageSize: 20,
  PageNumber: 1,
  ProductTypeId: 0,
};
let FilterQueryCache = defaultFilter as Api.GetPagedTestsQuery | null;

interface ParamTest {
  modelId: string,
  productTypeId: string
}

const Tests = () => {
  let routerHistory = useHistory();
  let { modelId, productTypeId } = useParams<ParamTest>();
  const { setMsgConfirmDialog, setCallBackConfirmDialog } = React.useContext(DialogContext);
  const { setSelectedMenuItem } = React.useContext(LeftMenuContext);
  const { userTokenInfo } = useToken();
  const { t } = useTranslation();
  const _columns = [
    {
      key: 'action',
      name: '',
      isResizable: true,
      minWidth: 20,
      maxWidth: 20,
      onRender: (item: Api.Test) => {
        let menuItems: IContextualMenuItem[] = [
          {
            key: 'Edit',
            text: t('Edit'),
            onClick: (ev) => {
              SetItemSelected(item);
              SetIsOpenModal(true);
            },
            disabled: !TestService.allowEditTest(item),
          },
        ];
        if (userTokenInfo && userTokenInfo.Role !== 'Vendor') {
          menuItems.push({
            key: 'UnApprove',
            text: TestService.isExpired(item) ? t('UnApproveExpired') : t('UnApprove'),
            onClick: (ev) => {
              SetItemSelected(item);
              SetIsOpenModalUnApprove(true);
            },
            disabled: TestService.isExpired(item) || TestService.allowApproveTest(item),
          });
          menuItems.push({
            key: 'Approve',
            text: TestService.isExpired(item) ? t('ApproveExpired') : t('Approve'),
            onClick: (ev) => {
              if (item.Id) {
                ApproveItem(item.Id);
              }
            },
            disabled: TestService.isExpired(item) || !TestService.allowApproveTest(item),
          });
        }
        menuItems.push({
          key: 'Delete',
          text: t('Delete'),
          onClick: (ev) => {
            setMsgConfirmDialog(t('AreYouSureYouWantToDeleteThisData'));
            setCallBackConfirmDialog({ action: deleteItem, param: item.Id });
          },
          disabled: !TestService.allowDeleteTest(item),
        });
        return <ButtonMenuContext ClassName={'menuContextDefault'} MenuItems={menuItems} IconName={'MoreVertical'} />;
      },
    },
    {
      key: 'Name',
      name: t('TestName'),
      fieldName: 'Name',
      className: 'flex-center',
      isResizable: true,
      minWidth: 300,
    },
    {
      key: 'ComponentModel.Name',
      name: t('ComponentModel'),
      className: 'flex-center',
      maxWidth: 300,
      minWidth: 200,
      onRender: (item: Api.Test) => {
        return item.ComponentModel?.Name;
      },
    },
    {
      key: 'Component.Name',
      name: t('Component'),
      className: 'flex-center',
      maxWidth: 300,
      minWidth: 200,
      onRender: (item: Api.Test) => {
        return item.Component?.Name;
      },
    },
    {
      key: 'Vendor.Name',
      name: t('ProductVendor'),
      className: 'flex-center',
      maxWidth: 200,
      minWidth: 200,
      onRender: (item: Api.Test) => {
        return item.Vendor?.Name;
      },
    },
    {
      key: 'ExpiredDate',
      name: t('Expired'),
      className: 'flex-center',
      maxWidth: 200,
      minWidth: 200,
      onRender: (item: Api.Test) => {
        return moment(item.ExpiredDate).format('DD/MM/yyyy');
      },
    },
    {
      key: 'IsApproved',
      name: t('Status'),
      className: 'flex-center',
      maxWidth: 100,
      minWidth: 100,
      onRender: (item: Api.Test) => {
        let status = commonfn.getTestStatus(item);
        let iconName = 'Clock';
        if (status === Api.TestStatusQueryEnum.Approved) {
          iconName = 'SkypeCircleCheck';
        }
        /* if (status == Api.TestStatusQueryEnum.Expired) {
                    iconName = "Warning";
                } */
        return (
          <>
            <Icon iconName={iconName} className={status} style={{}}></Icon>&nbsp; <span>{t(status)}</span>
          </>
        );
      },
    },
  ] as IColumn[];
  const addIcon: IIconProps = { iconName: 'Filter' };
  const clearIcon: IIconProps = { iconName: 'ClearFilter' };
  const [isChangeFilter, SetIsChangeFilter] = React.useState(false);
  const [isOpenModal, SetIsOpenModal] = React.useState(false);
  const [isOpenModalUnApprove, SetIsOpenModalUnApprove] = React.useState(false);
  const [isOpenModalFilter, SetIsOpenModalFilter] = React.useState(false);
  const [itemSelected, SetItemSelected] = React.useState<Api.Test | null>(null);
  const [listProductType, setListProductType] = React.useState<Api.ProductType[]>([]);
  const [FilterQuery, setFilterQuery] = React.useState<Api.GetPagedTestsQuery>(defaultFilter);
  const [listMaster, setListMaster] = React.useState<Api.TestPaginatedResult | null>(null);
  const [isShowLoading, SetIsShowLoading] = React.useState(true);
  const [columns, setColumns] = React.useState<any[]>(_columns);
  const [selectedKey, setSelectedKey] = React.useState<string>(productTypeId);

  const _onColumnClick = (event: MouseEvent<HTMLElement> | undefined, column: IColumn | undefined) => {
    if (column?.name) {
      SetIsShowLoading(true);
      const newColumns: IColumn[] = columns.slice();
      const currColumn: IColumn = newColumns.filter((currCol) => column?.key === currCol.key)[0];
      newColumns.forEach((newCol: IColumn) => {
        if (newCol === currColumn) {
          currColumn.isSortedDescending = !currColumn.isSortedDescending;
          currColumn.isSorted = true;
        } else {
          newCol.isSorted = false;
          newCol.isSortedDescending = true;
        }
      });

      setFilterQuery({ ...FilterQuery, OrderBy: [{ ColumnName: column?.key, IsDesc: currColumn.isSortedDescending }] });
      setColumns(newColumns);
    }
  };
  const getList = async () => {
    SetIsShowLoading(true);
    let data = (await TestsApi.apiTestsPagedPost(FilterQuery)).data;
    setListMaster(data);
    setTimeout(() => {
      SetIsShowLoading(false);
    }, 500);
  };
  const deleteItem = async (id: number) => {
    await TestsApi.apiTestsIdSetStatesPatch(id, Api.StatesEnum.Delete);
    setFilterQuery({ ...FilterQueryCache, PageNumber: 1 });
  };
  const ApproveItem = async (id: number) => {
    if (globalData.Configurations?.ModuleFollowTestApproved === Api.ModuleFollowTestApprovedEnum.NotApplicable) {
      await TestsApi.apiTestsIdSetApprovedPatch(id, true, false);
      setFilterQuery({...FilterQueryCache, PageNumber: 1});
    } else {
      setMsgConfirmDialog(t('AreYouSureYouWantToApproveThisTest'));
      setCallBackConfirmDialog({
        action: async () => {
          await TestsApi.apiTestsIdSetApprovedPatch(id, true, true);
          setFilterQuery({ ...FilterQueryCache, PageNumber: 1 });
        },
        param: id,
      });
    }
  };
  const getAllProductTypes = async () => {
    if (listProductType.length > 0) return;
    let data = (await UserApi.apiUserGetCurrentUserProductTypeGet()).data;
    setListProductType(data || []);
    if(productTypeId)
    {
      setFilterQuery({
        ...FilterQuery,
        ProductTypeId: Number(productTypeId), CModelId: modelId ? Number(modelId) : 0
      });
      return;
    }
    if (data && data?.length > 0) {
      setFilterQuery({
        ...FilterQuery,
        ProductTypeId: data[0].Id || 0,
      });
    }
  };

  React.useEffect(() => {
    getAllProductTypes();
    setSelectedMenuItem('Tests');
  }, []);
  let timeOutGetList: any = null;
  React.useEffect(() => {
    if (!FilterQuery.ProductTypeId) 
    {
      SetIsShowLoading(false);
      return;
    }
    
    if (FilterQueryCache?.SearchString !== FilterQuery.SearchString) {
      if (timeOutGetList) {
        clearTimeout(timeOutGetList);
        timeOutGetList = null;
      }
      timeOutGetList = setTimeout(() => {
        getList();
        timeOutGetList = null;
      }, 350);
      FilterQueryCache = FilterQuery;
      return () => window.clearTimeout(timeOutGetList);
    } else {
      getList();
      FilterQueryCache = FilterQuery;
    }
  }, [FilterQuery]);
  React.useEffect(() => {
    if (
      FilterQuery.ComponentId !== 0 ||
      FilterQuery.VendorId !== 0 ||
      FilterQuery.Status !== Api.TestStatusQueryEnum.All
    ) {
      SetIsChangeFilter(true);
    } else {
      SetIsChangeFilter(false);
    }
  }, [FilterQuery.ComponentId, FilterQuery.VendorId, FilterQuery.Status]);
  return (
    <div className="test">
      <div className={'page-header'}>
        <Label>{t('Tests')}</Label>
      </div>
      <Pivot
        className="tab-header"
        style={{ overflowY: 'hidden', overflowX: 'auto' }}
        selectedKey={selectedKey}
        onLinkClick={(item) => {
          setFilterQuery({ ...FilterQuery, ProductTypeId: parseInt(item?.props.itemKey || '0'), PageNumber: 1});
          setSelectedKey(parseInt(item?.props.itemKey || '0').toString());
        }}
      >
        {listProductType.map((item) => {
          return (
            <PivotItem key={item.Id} headerText={item.Name || ''} itemKey={(item.Id || '').toString()}></PivotItem>
          );
        })}
      </Pivot>

      <div className="page-content ms-Grid" dir="ltr">
        <Loading isShow={isShowLoading}></Loading>
        <div className="ms-Grid  form-list" dir="ltr">
          <div className="ms-Grid-row display-flex">
            <div className="ms-Grid-col padding-left-0 margin-right-auto ms-md2" style={{ minWidth: 250 }}>
              <SearchBox
                placeholder={t('Search')}
                onChange={(e, newValue) => {
                  setFilterQuery({ ...FilterQuery, SearchString: newValue || '', PageNumber: 1 });
                }}
              />
            </div>
            <div className="ms-Grid-col ms-sm6">
              <Stack horizontal className="header-action">
                {(isChangeFilter && (
                  <CommandBarButton
                    iconProps={clearIcon}
                    text={t('ClearFilter')}
                    className={'margin-left-auto'}
                    onClick={() => {
                      setFilterQuery({
                        ...defaultFilter,
                        PageSize: FilterQuery.PageSize,
                        ProductTypeId: FilterQuery.ProductTypeId,
                        PageNumber: 1,
                      });
                    }}
                  />
                )) || (
                  <CommandBarButton
                    iconProps={addIcon}
                    text={t('Filter')}
                    className={'margin-left-auto'}
                    onClick={() => {
                      SetIsOpenModalFilter(true);
                    }}
                  />
                )}
                &nbsp; &nbsp;
                <PrimaryButton
                  text={t('New')}
                  onClick={() => {
                    SetIsOpenModal(true);
                    SetItemSelected(null);
                  }}
                />
              </Stack>
            </div>
          </div>
        </div>
        <div className="ms-Grid-row">
          {(listMaster?.Data?.length || 0) > 0 && (
            <DetailsList
              items={listMaster?.Data || []}
              columns={columns}
              checkboxVisibility={CheckboxVisibility.hidden}
              onColumnHeaderClick={_onColumnClick}
              onRenderRow={(props) => {
                return _renderRow(props || ({} as IDetailsRowProps), () => {
                  routerHistory.push('/test/detail/' + props?.item.Id);
                });
              }}
            />
          )}
          <NoDataFound isShow={(listMaster?.Data?.length ?? 0) === 0}></NoDataFound>
          <Paging
            CurrentPage={FilterQuery.PageNumber}
            TotalPage={listMaster?.TotalPages || 0}
            onChangePage={(page, pageSize) => {
              setFilterQuery({ ...FilterQuery, PageNumber: page, PageSize: pageSize });
            }}
          ></Paging>
        </div>
        <ModaFilterTest
          IsOpen={isOpenModalFilter}
          FilterItem={FilterQuery}
          onCloseModal={() => {
            SetIsOpenModalFilter(false);
          }}
          onOkClick={(filterItem) => {
            setFilterQuery(filterItem);
            SetIsOpenModalFilter(false);
          }}
        ></ModaFilterTest>
        <ModalTest
          productypeId={FilterQuery.ProductTypeId || null}
          IsOpen={isOpenModal}
          Item={itemSelected}
          onSaveClick={() => {
            setFilterQuery({ ...FilterQuery, PageNumber: 1 });
          }}
          onCloseModal={() => {
            SetIsOpenModal(false);
          }}
        ></ModalTest>
        <ModalUnApproveTest
          IsOpen={isOpenModalUnApprove}
          Item={itemSelected}
          onSaveClick={() => {
            setFilterQuery({ ...FilterQuery, PageNumber: 1 });
          }}
          onCloseModal={() => {
            SetIsOpenModalUnApprove(false);
          }}
        ></ModalUnApproveTest>
      </div>
    </div>
  );
};
export default Tests;
